import { fetch } from "./api_utils";

const getSession = () => fetch("/session");

export { getSession };
